const Payment = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer2"
      d="M58 38V28a8 8 0 0 0-16 0v10h-4v16h24V38zm-6 10a2 2 0 1 1-4 0v-4a2 2 0 1 1 4 0zm2-10h-8V28a4 4 0 0 1 8 0z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M38 28a11.9 11.9 0 0 1 3.1-8H2v19.6A2.4 2.4 0 0 0 4.4 42H34v-8h4zm-21.6 8H10a2 2 0 0 1 0-4h6.4a2 2 0 0 1 0 4zm9.6-8H10a2 2 0 0 1 0-4h16a2 2 0 0 1 0 4zm24-15.6a2.4 2.4 0 0 0-2.4-2.4H4.4A2.4 2.4 0 0 0 2 12.4V16h48z"
      fill={color}
    ></path>
  </svg>
);

export default Payment;
